/**
 * Vitrine çıkarılan PLATFORM YETENEKLERİ ve SÜRÜM NOTLARI.
 *
 * ⚠️ Buraya yalnızca GERÇEKTEN ÇALIŞAN ve doğrulanmış yetenek yazılır.
 * Önceki sürümde bu bölümde sesli sipariş, sosyal medyadan sipariş, öngörülü
 * bakım ve pazaryeri entegrasyonu duruyordu — dördü de üründe YOK. Landing'de
 * olmayan bir özelliği vaat etmek, demo görüşmesinde geri alınmak zorunda
 * kalınan bir söz demek.
 *
 * `stat` alanı UYDURMA YÜZDE DEĞİL: kartın büyük rakamı ölçülebilir bir
 * gerçeği söylüyor ("06:00 mali gün başlangıcı" gibi), pazarlama için
 * üretilmiş bir "+%52 kâr artışı" değil.
 *
 * `href` verilen kart tıklanabilir: yeteneğin kendi sayfası varsa ziyaretçi
 * oraya bir dokunuşla gitmeli.
 */

export const capabilities = [
  {
    id: 'ar-menu',
    title: '3D ve AR Menü',
    description: 'Misafir yemeği telefonunda çevirir, AR ile gerçek boyutunda masasına koyar. Uygulama kurulmaz.',
    icon: 'Box',
    color: 'bg-amber-600',
    stat: 'Uygulamasız',
    statLabel: 'iPhone ve Android tarayıcısında',
    href: '/ar-menu',
    detail: {
      title: 'Taramadan menüye',
      points: [
        'Modeli ekibimiz sizin tabağınızdan tarar',
        'Model yalnızca misafir 3D dediğinde iner — menü yavaşlamaz',
        'Yayından önce her model telefonda AR ile kontrol edilir',
        'Paket kapansa da model silinmez, yalnızca gizlenir'
      ]
    }
  },
  {
    id: 'offline-first',
    title: 'Çevrimdışı Çalışma',
    description: 'İnternet kesildiğinde adisyon durmaz. Bağlantı gelince her şey sırasıyla senkronize olur.',
    icon: 'WifiOff',
    color: 'bg-slate-700',
    stat: '0 kayıp',
    statLabel: 'kablo çekildiğinde',
    detail: {
      title: 'Operasyon günlüğü (op-log)',
      points: [
        'Masa açma, ürün ekleme, mutfağa gönderme çevrimdışı çalışır',
        'Nakit ödeme çevrimdışı alınabilir',
        'Sıra cihaz saatine göre — geç senkronlanan tablet en sona düşmez',
        'Aynı işlem iki kez gitse bile tek kez işlenir'
      ]
    }
  },
  {
    id: 'kds',
    title: 'Mutfak Ekranı (KDS)',
    description: 'Garson gönderir, mutfak anında görür. İstasyona göre süzülür, bekleyen fiş renk değiştirir.',
    icon: 'ChefHat',
    color: 'bg-orange-500',
    stat: 'Fiyatsız',
    statLabel: 'mutfak fişi — kural',
    detail: {
      title: 'Mutfak akışı',
      points: [
        'Hazırlanıyor → hazır → servis edildi durum akışı',
        'İstasyon süzgeci: bar siparişi mutfağa düşmez',
        'Bekleme süresi arttıkça aciliyet uyarısı',
        'Mutfak fişinde fiyat hiçbir zaman yazmaz'
      ]
    }
  },
  {
    id: 'desktop-cash',
    title: 'Masaüstü Kasa + Fiş Yazıcısı',
    description: 'Kasa bilgisayarında çalışan uygulama, yerel ağdaki fiş yazıcısına doğrudan bağlanır.',
    icon: 'Printer',
    color: 'bg-gray-800',
    stat: 'Win · macOS',
    statLabel: 'indir, kendiliğinden güncellenir',
    href: '/download',
    detail: {
      title: 'Fiş ve kasa kabuğu',
      points: [
        'ESC/POS byte üretimi, Türkçe karakter için CP857',
        'Mutfak fişi istasyona göre ayrı ayrı basılır',
        'Gönderilmemiş işlemler diske yazılır — kasa kapanıp açılsa da durur',
        'Yazma başladıktan sonra tekrar denenmez: çift fiş çıkmaz',
        'Yeni sürüm arka planda iner, kasa kapanırken kurulur'
      ]
    }
  },
  {
    id: 'recipe-cost',
    title: 'Reçete ve Maliyet',
    description: 'Ürün mutfağa gönderildiği an hammadde stoktan düşer. Maliyet ve kâr marjı kendiliğinden çıkar.',
    icon: 'Scale',
    color: 'bg-green-600',
    stat: '4 hane',
    statLabel: 'miktar hassasiyeti',
    detail: {
      title: 'Reçete ve sayım',
      points: [
        'Tüketim ödemede değil mutfağa gönderimde doğar',
        'Fire oranı reçetenin parçası (soyulan patatesin kaybı dahil)',
        'Stok sayımı: beklenen miktar sayım açılışında donar',
        'Teorik-fiili fark raporu — kayıp nerede, sayıyla görünür'
      ]
    }
  },
  {
    id: 'menu-engineering',
    title: 'Menü Mühendisliği',
    description: 'Hangi ürün kazandırıyor, hangisi menüde yer işgal ediyor? Dört kutuya oturtur ve ne yapılacağını söyler.',
    icon: 'Grid2x2',
    color: 'bg-purple-500',
    stat: '4 kutu',
    statLabel: 'yıldız · iş atı · bilmece · ölü',
    detail: {
      title: 'Karar listesi',
      points: [
        'Katkı payı ve popülerliğe göre sınıflandırma',
        'Ağırlıklı ortalama katkı payı — nadir satılan pahalı ürün eşiği bozmaz',
        'Zarar eden ürün için kritik eylem uyarısı',
        'Maliyeti bilinmeyen ürün analiz dışında bırakılır, "yıldız" gibi gösterilmez'
      ]
    }
  },
  {
    id: 'branch-pricelist',
    title: 'Şube ve Fiyat Listeleri',
    description: 'Menü merkezden yönetilir; paket serviste, online kanalda ya da belirli saatlerde farklı fiyat uygulanır.',
    icon: 'Building2',
    color: 'bg-teal-600',
    stat: 'Happy hour',
    statLabel: 'saat aralıklı fiyat',
    detail: {
      title: 'Fiyat kuralları',
      points: [
        'Kanal bazlı fiyat: salon, paket, online ayrı ayrı',
        'Şube bazlı fiyat ve şubede ürün kapatma',
        'Gece yarısını aşan saat aralığı desteklenir (22:00 → 02:00)',
        'Listeler üst üste binmez: en özel olan kural kazanır'
      ]
    }
  },
  {
    id: 'partnership-finance',
    title: 'Ortaklık ve İşletme Finansı',
    description: 'Kâr kimin cebine ne kadar giriyor? Ortaklık payları muhasebe defteri disipliniyle hesaplanır.',
    icon: 'Handshake',
    color: 'bg-indigo-500',
    stat: 'Çift taraflı',
    statLabel: 'muhasebe defteri',
    detail: {
      title: 'Ortaklık defteri',
      points: [
        'Üç katılım biçimi: kâr-gider ortağı, sessiz ortak, ciro payı',
        'Sermaye iadesi kâr dağıtımından önce',
        'Ortağın cebinden ödediği gider iki kez düşülmez',
        'Kayıt silinmez, ters kayıt yazılır — geçmiş olduğu gibi durur'
      ]
    }
  },
  {
    id: 'campaign-discount',
    title: 'Kampanya ve Onaylı İskonto',
    description: 'Kampanya bir kuraldır, kendiliğinden uygulanır; iskonto bir karardır, yetkili onayı isteyebilir.',
    icon: 'Percent',
    color: 'bg-rose-500',
    stat: 'PIN onayı',
    statLabel: 'iptal · ikram · iskonto',
    detail: {
      title: 'İndirim yönetimi',
      points: [
        'Koşulu sağlayan adisyona kampanya otomatik uygulanır',
        'Kampanyalar varsayılan olarak üst üste binmez',
        'Manuel iskonto kampanya yeniden hesaplandığında silinmez',
        'Onay eşiği firma ayarı: kapatılabilir, roller muaf tutulabilir'
      ]
    }
  },
  {
    id: 'business-day',
    title: 'İşletme Günü Bazlı Raporlama',
    description: 'Gece 01:00 satışı önceki güne yazılır. Kasa ve ciro aynı günü sayar.',
    icon: 'CalendarClock',
    color: 'bg-blue-600',
    stat: '06:00',
    statLabel: 'mali gün başlangıcı',
    detail: {
      title: 'Mali gün',
      points: [
        'Gün başlangıcı saati işletmeye göre ayarlanır',
        'Adisyon numarası her işletme günü sıfırlanır',
        'Çevrimdışı adisyonda gün, cihazın masayı açtığı ana göre belirlenir',
        'Kasa ve satış raporu aynı günü sayar'
      ]
    }
  },
  {
    id: 'operation-reports',
    title: 'Operasyon Raporları',
    description: 'Kaç kişiyle vardiya kurulacağını tahminle değil, saatlik yoğunluk grafiğiyle karar verin.',
    icon: 'BarChart3',
    color: 'bg-cyan-600',
    stat: 'Saatlik',
    statLabel: 'yoğunluk ve devir hızı',
    detail: {
      title: 'Rapor seti',
      points: [
        'Saatlik yoğunluk (eksen mali gün başlangıcından)',
        'Masa devir hızı ve ortalama oturma süresi',
        'Garson performansı',
        'Zaiyat raporu: iptal ve ikram ayrı ayrı'
      ]
    }
  },
  {
    id: 'permissions',
    title: 'Yetki, PIN ve Oturum Güvenliği',
    description: 'Kim ne yapabilir, hangi işlem ikinci bir kişinin onayını ister — ikisi ayrı ayrı ayarlanır.',
    icon: 'ShieldCheck',
    color: 'bg-emerald-600',
    stat: '15 dk',
    statLabel: 'oturum anahtarı ömrü',
    detail: {
      title: 'Erişim denetimi',
      points: [
        'Rol bir şablon; personel bazında yetki verilip alınabilir',
        'Personel PIN ile hızlı cihaz geçişi',
        'Şifre değişince o kullanıcının tüm oturumları düşer',
        'Açık oturumlar listelenir ve tek tek kapatılabilir'
      ]
    }
  },
  {
    id: 'invoice-document',
    title: 'Fatura ve Cari Belge',
    description: 'Satış ve alış faturaları boşluksuz numaralandırma ve oran bazlı KDV kırılımıyla üretilir.',
    icon: 'FileText',
    color: 'bg-amber-600',
    stat: 'Boşluksuz',
    statLabel: 'fatura numarası',
    detail: {
      title: 'Belge katmanı',
      points: [
        'Oran bazlı KDV kırılımı ve tutarlılık denetimi',
        'Seri + yıl + sıra numaralandırma',
        'Cari hesap ve stok ile bağlantılı',
        'e-Fatura gönderimi entegratör anlaşmasıyla açılacak'
      ]
    }
  }
];

/**
 * Sürüm notları — "son zamanlarda ne eklendi" bölümünün kaynağı.
 * En yeni en üstte. Tarihler gerçek teslim tarihleri.
 */
export const releases = [
  {
    date: '2026-09-28',
    title: '3D ve AR Menü',
    icon: 'Box',
    color: 'bg-amber-600',
    summary: 'QR menüde ürün 3D dönüyor, "AR\'da Gör" ile gerçek boyutunda masaya oturuyor. Modelleri ekibimiz tarıyor; QR Menü Pro paketinde.',
    tag: 'QR Menü Pro',
    href: '/ar-menu'
  },
  {
    date: '2026-09-25',
    title: 'Kasa Uygulaması İndirilebilir',
    icon: 'Download',
    color: 'bg-gray-800',
    summary: 'Windows ve macOS için kurulum paketi. Yeni sürüm arka planda iniyor, kasa kapanırken kuruluyor; gönderilmemiş işlem varken bekliyor.',
    tag: 'Masaüstü',
    href: '/download'
  },
  {
    date: '2026-09-24',
    title: 'Kurye Yönetimi',
    icon: 'Bike',
    color: 'bg-orange-600',
    summary: 'Siparişi panelden kuryeye atama, kurye başına hakediş, performans ve gecikme raporu; kuryedeki nakit ayrı izleniyor.',
    tag: 'Kurye'
  },
  {
    date: '2026-09-21',
    title: 'Stok Kategorileri Sizin Tanımınız',
    icon: 'Tags',
    color: 'bg-lime-600',
    summary: 'Hazır kovalar yerine işletmenin kendi kategorileri: "Et & Tavuk", "Kahve Çekirdeği", "Manav". Kategorisiz kartlar ayrı süzülüyor.',
    tag: 'Stok'
  },
  {
    date: '2026-09-12',
    title: 'Kullanım Rehberi',
    icon: 'BookOpen',
    color: 'bg-sky-600',
    summary: 'Kurulumdan gün sonuna adım adım rehber; panelden ve siteden aranabiliyor.',
    tag: 'Destek',
    href: '/guide'
  },
  {
    date: '2026-09-05',
    title: 'QR Menüde 8 Tema ve Canlı Önizleme',
    icon: 'Palette',
    color: 'bg-fuchsia-600',
    summary: 'Üç düzen × renk paleti. Panelde telefon çerçevesinde gerçek menünüzü görerek seçiyorsunuz; kaydedene kadar misafirin menüsü değişmiyor.',
    tag: 'QR Menü'
  },
  {
    date: '2026-09-04',
    title: 'Satın Alma Zinciri ve Şube Stoğu',
    icon: 'Truck',
    color: 'bg-emerald-700',
    summary: 'Sipariş → mal kabul → fatura. Stok şube bazında tutuluyor, koli/kilo çevrimi ürün kartında tanımlanıyor.',
    tag: 'Stok'
  },
  {
    date: '2026-09-03',
    title: 'Gün Sonu Mutabakatı ve Bekletilen Satış',
    icon: 'ClipboardCheck',
    color: 'bg-indigo-600',
    summary: 'Kasada sayılan, bankaya geçen ve hakediş olarak gelen para sistemle karşılaştırılıyor. Tezgahta satış bekletilip geri açılabiliyor.',
    tag: 'Finans'
  },
  {
    date: '2026-09-01',
    title: 'Tartılı Satış, Açık Fiyat, Adisyonsuz Satış',
    icon: 'Scale',
    color: 'bg-teal-700',
    summary: 'Kilo fiyatlı ürün gram hassasiyetinde, tutarı kasiyerin girdiği ürün ve masasız hızlı satış modu. Kategori bazında mutfak/fiş davranışı.',
    tag: 'POS'
  },
  {
    date: '2026-08-29',
    title: 'Menü Mühendisliği',
    icon: 'Grid2x2',
    color: 'bg-purple-500',
    summary: 'Ürünler katkı payı ve popülerliğe göre dört kutuya yerleşiyor; zarar eden ürün için somut eylem listesi çıkıyor.',
    tag: 'Yeni ekran'
  },
  {
    date: '2026-08-29',
    title: 'Reçete, Maliyet ve Otomatik Stok Düşümü',
    icon: 'Scale',
    color: 'bg-green-600',
    summary: 'Ürün mutfağa gönderildiği an hammadde stoktan düşüyor. Stok sayımı ve teorik-fiili fark raporu geldi.',
    tag: 'Stok'
  },
  {
    date: '2026-08-29',
    title: 'Merkezi Menü, Şube ve Fiyat Listeleri',
    icon: 'Building2',
    color: 'bg-teal-600',
    summary: 'Kanal ve şube bazlı fiyat listesi, saat aralıklı fiyat, şubede ürün kapatma ve raporlarda şube süzgeci.',
    tag: 'Çoklu şube'
  },
  {
    date: '2026-08-28',
    title: 'Ortaklık ve İşletme Finansı',
    icon: 'Handshake',
    color: 'bg-indigo-500',
    summary: 'Çift taraflı defter, üç katılım biçimi, sermaye iadesi, dönem kapanışı ve ortaklar arası mahsup.',
    tag: 'Finans'
  },
  {
    date: '2026-08-28',
    title: 'Hesap Güvenliği',
    icon: 'ShieldCheck',
    color: 'bg-emerald-600',
    summary: 'Şifre değişince tüm oturumlar düşüyor, açık oturumlar listeleniyor ve tek tek kapatılabiliyor.',
    tag: 'Güvenlik'
  },
  {
    date: '2026-08-27',
    title: 'Sadakat Puanı',
    icon: 'Gift',
    color: 'bg-pink-500',
    summary: 'Telefon numarasıyla tanıma, ayarlanabilir kazanım oranı, kasada tek dokunuşla puan harcama.',
    tag: 'Yeni modül'
  },
  {
    date: '2026-08-25',
    title: 'QR Sipariş, Garson Çağır, Hesap İste',
    icon: 'ScanLine',
    color: 'bg-teal-500',
    summary: 'Misafir masadan sipariş veriyor; çağrılar POS salon ekranında bekleme süresiyle görünüyor.',
    tag: 'Yeni modül'
  },
  {
    date: '2026-08-24',
    title: 'Masaüstü Kasa, Fiş Yazıcısı ve Çevrimdışı Dayanıklılık',
    icon: 'Printer',
    color: 'bg-gray-800',
    summary: 'Kasa uygulaması yerel ağdaki yazıcıya bağlanıyor; gönderilmemiş işlemler kasa kapanıp açılsa da kaybolmuyor.',
    tag: 'Donanım'
  },
  {
    date: '2026-08-19',
    title: 'Operasyon Raporları',
    icon: 'BarChart3',
    color: 'bg-cyan-600',
    summary: 'Saatlik yoğunluk, masa devir hızı, garson performansı ve zaiyat raporu.',
    tag: 'Rapor'
  },
  {
    date: '2026-08-15',
    title: 'Mutfak Ekranı (KDS)',
    icon: 'ChefHat',
    color: 'bg-orange-500',
    summary: 'İstasyon süzgeci ve aciliyet uyarısıyla mutfak ekranı; fiş kağıdına bağımlılık ortadan kalkıyor.',
    tag: 'Mutfak'
  },
  {
    date: '2026-08-12',
    title: 'POS Çekirdeği Yeniden Yazıldı',
    icon: 'Cpu',
    color: 'bg-blue-600',
    summary: 'Kuruş bazlı para hesabı, işletme günü, hesap bölme, kasa/vardiya, yetki matrisi ve çevrimdışı operasyon günlüğü.',
    tag: 'Çekirdek'
  }
];
